import parse from 'html-react-parser';

import { cme_kurs } from "./Global/Kurs"
import { mainVideo } from "./Global/Video"

import './../css/single-thumbnail.css'




// ------ thumbnail click-listener ------
function jumpToTime(time) {
    // set slide time
    var targetTime = parseFloat(time + 0.25); // + small buffer for app
    mainVideo.video.currentTime = targetTime;
}


// ------ mouse-hover enlarge slide-image ------
function onOverThumbnail(e) {
    var currentThumb = e.currentTarget;
    currentThumb.style.width = "96%";
    var parentNode = currentThumb.parentNode;
    var textContainer = parentNode.childNodes[1];
    textContainer.style.display = 'none';
}

function onOutThumbnail(e) {
    var currentThumb = e.currentTarget;
    currentThumb.style.width = "30%";
    var parentNode = currentThumb.parentNode;
    var textContainer = parentNode.childNodes[1];
    textContainer.style.display = 'block';
}

function getSlideType(slideSource) {
    var slideType = slideSource.split('.');
    slideType = slideType[slideType.length - 1];
    return slideType;
}

export const SlideThumbnail = ({ id, thisSlide }) => {

    // determine slide type
    var slideType = getSlideType(thisSlide.source);
    var posterSource = thisSlide.source;

    // give thumbnail a different poster-image if its a video
    if (slideType == "mp4") {
        try {
            posterSource = process.env.PUBLIC_URL + '/assets/images/' + thisSlide.videoPoster;
        }
        catch (e) {
            alert(`Es wurde kein Attribut "videoPoster" bei Slide ${thisSlide.chartNr} gefunden`);
        }
    }

    return (
        <div id={id} className="chart_container single-thumbnail" onClick={(cme_kurs.isPowerPoint) ? () => mainVideo.onSlideChange(thisSlide) : () => jumpToTime(thisSlide.starttime)} >
            <img alt="chart" className="chart_image_container" src={posterSource} onMouseOver={onOverThumbnail} onMouseOut={onOutThumbnail} />
            <div className="chart_text_container">
                <span className="chart_nr">{thisSlide.chartNr}</span>|
                <span className="chart_title">{parse(thisSlide.title)}</span>
            </div>

        </div>

    )
}

export default SlideThumbnail